function matchRoute(currentPath: string, routesToCompareTo: string[]): boolean {
    for (const route of routesToCompareTo) {
        // Check if it's a wildcard route
        if (route.includes('*')) {
            // Convert wildcard pattern to regex
            // Escape special regex chars and replace * with .*
            const pattern = '^' + 
                route.replace(/[.+?^${}()|[\]\\]/g, '\\$&')
                    .replace('\\*', '.*') + 
                '(\\/.*)?$'; // Allow partial matches for wildcard routes
            const regex = new RegExp(pattern);

            if (regex.test(currentPath)) {
                return true;
            }
        } 
        // Exact match
        else if (route === currentPath) {
            return true;
        }
    }
    return false;
}

export { matchRoute };